export default "/build/static/fonts/Whitney-LightItal_Web.woff2";